export const META_DATA = {
	title: 'University Guides',
	description:
		'Browse our range of university guides at Uni Compare, designed to provide you with everything you need. From career guides to city guides, we&#39;ve got you covered!',
};

export const RANKINGS_MAPPING = [
	{ guideName: 'Accounting Degree', rankingsSlug: '', courseSearchSlug: 'accounting' },
	{
		guideName: 'Aerospace Engineering',
		rankingsSlug: '',
		courseSearchSlug: 'aerospace-engineering',
	},
	{
		guideName: 'African Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'african-studies',
	},
	{
		guideName: 'Agriculture Degree',
		rankingsSlug: 'agriculture-and-food',
		courseSearchSlug: 'agriculture',
	},
	{
		guideName: 'American Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'american-studies',
	},
	{ guideName: 'Anatomy Degree', rankingsSlug: '', courseSearchSlug: 'anatomy' },
	{
		guideName: 'Animal Science Degree',
		rankingsSlug: '',
		courseSearchSlug: 'animal-science',
	},
	{
		guideName: 'Anthropology Degree',
		rankingsSlug: 'anthropology',
		courseSearchSlug: 'anthropology',
	},
	{
		guideName: 'Archaeology Degree',
		rankingsSlug: 'archaeology',
		courseSearchSlug: 'archaeology',
	},
	{
		guideName: 'Architecture Degree',
		rankingsSlug: 'architecture-planning-and-built-environment',
		courseSearchSlug: 'architecture',
	},
	{
		guideName: 'Art Degree',
		rankingsSlug: 'art-and-design',
		courseSearchSlug: 'fine-art',
	},
	{
		guideName: 'Asian Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'asian-studies',
	},
	{ guideName: 'Astrophysics', rankingsSlug: '', courseSearchSlug: 'astrophysics' },
	{
		guideName: 'Biology Degree',
		rankingsSlug: 'biological-sciences',
		courseSearchSlug: 'biology',
	},
	{
		guideName: 'Business and Construction Management Degree',
		rankingsSlug: 'business-and-management-studies',
		courseSearchSlug: 'construction-management',
	},
	{
		guideName: 'Business Degree',
		rankingsSlug: 'business-and-management-studies',
		courseSearchSlug: 'business-studies',
	},
	{
		guideName: 'Celtic Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'celtic-studies',
	},
	{
		guideName: 'Chemical Engineering Degree',
		rankingsSlug: '',
		courseSearchSlug: 'chemical-engineering',
	},
	{
		guideName: 'Chemistry Degree',
		rankingsSlug: 'chemistry',
		courseSearchSlug: 'chemistry',
	},
	{
		guideName: 'Civil Engineering Degree',
		rankingsSlug: '',
		courseSearchSlug: 'civil-engineering',
	},
	{
		guideName: 'Classics Degree',
		rankingsSlug: 'classics',
		courseSearchSlug: 'classical-studies',
	},
	{
		guideName: 'Communications Degree',
		rankingsSlug: '',
		courseSearchSlug: 'media-and-communication-studies',
	},
	{
		guideName: 'Computer Science Degree',
		rankingsSlug: 'computer-science',
		courseSearchSlug: 'computer-science',
	},
	{
		guideName: 'Counselling Degree',
		rankingsSlug: '',
		courseSearchSlug: 'counselling',
	},
	{
		guideName: 'Criminology Degree',
		rankingsSlug: '',
		courseSearchSlug: 'criminology',
	},
	{ guideName: 'Dance Degree', rankingsSlug: '', courseSearchSlug: 'dance' },
	{
		guideName: 'Dentistry Degree',
		rankingsSlug: 'medicine-and-dentistry',
		courseSearchSlug: 'dentistry',
	},
	{
		guideName: 'Design Degree',
		rankingsSlug: 'art-and-design',
		courseSearchSlug: 'design',
	},
	{
		guideName: 'Drama Degree',
		rankingsSlug: 'music-and-performing-arts',
		courseSearchSlug: 'drama',
	},
	{
		guideName: 'Economics Degree',
		rankingsSlug: 'economics',
		courseSearchSlug: 'economics',
	},
	{
		guideName: 'Education Studies Degree',
		rankingsSlug: 'teaching-and-education',
		courseSearchSlug: 'education-studies',
	},
	{
		guideName: 'Electrical Engineering Degree',
		rankingsSlug: '',
		courseSearchSlug: 'electrical-engineering',
	},
	{
		guideName: 'Engineering Degree',
		rankingsSlug: 'engineering',
		courseSearchSlug: 'civil-engineering',
	},
	{
		guideName: 'English Language Degree',
		rankingsSlug: 'english-language-and-literature',
		courseSearchSlug: 'english-language',
	},
	{
		guideName: 'English Literature Degree',
		rankingsSlug: 'english-language-and-literature',
		courseSearchSlug: 'english-literature',
	},
	{
		guideName: 'Environmental Science Degree',
		rankingsSlug: 'environmental-sciences',
		courseSearchSlug: 'environmental-sciences',
	},
	{ guideName: 'Fashion Degree', rankingsSlug: '', courseSearchSlug: 'fashion' },
	{ guideName: 'Film Degree', rankingsSlug: '', courseSearchSlug: 'film-studies' },
	{ guideName: 'Finance Degree', rankingsSlug: '', courseSearchSlug: 'finance' },
	{
		guideName: 'Fine Arts Degree',
		rankingsSlug: 'art-and-design',
		courseSearchSlug: 'fine-art',
	},
	{
		guideName: 'Food Science Degree',
		rankingsSlug: '',
		courseSearchSlug: 'food-science',
	},
	{
		guideName: 'Forensic Science Degree',
		rankingsSlug: '',
		courseSearchSlug: 'forensic-science',
	},
	{
		guideName: 'Forestry Degree',
		rankingsSlug: '',
		courseSearchSlug: 'forestry-and-arboriculture',
	},
	{ guideName: 'French Degree', rankingsSlug: '', courseSearchSlug: 'french-studies' },
	{
		guideName: 'Geography Degree',
		rankingsSlug: 'geography',
		courseSearchSlug: 'geography',
	},
	{ guideName: 'Geology Degree', rankingsSlug: '', courseSearchSlug: 'geology' },
	{
		guideName: 'German Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'german-studies',
	},
	{ guideName: 'History Degree', rankingsSlug: 'history', courseSearchSlug: 'history' },
	{
		guideName: 'Hospitality Degree',
		rankingsSlug: '',
		courseSearchSlug: 'hospitality-management',
	},
	{
		guideName: 'Human Resource Management Degree',
		rankingsSlug: '',
		courseSearchSlug: 'human-resource-management',
	},
	{
		guideName: 'Journalism Degree',
		rankingsSlug: 'media-journalism-and-communications',
		courseSearchSlug: 'journalism',
	},
	{
		guideName: 'Landscape Architecture Degree',
		rankingsSlug: '',
		courseSearchSlug: 'landscape-architecture-and-design',
	},
	{ guideName: 'Law Degree', rankingsSlug: 'law', courseSearchSlug: 'law' },
	{
		guideName: 'Linguistics Degree',
		rankingsSlug: 'modern-languages-and-linguistics',
		courseSearchSlug: 'linguistics',
	},
	{ guideName: 'Marketing Degree', rankingsSlug: '', courseSearchSlug: 'marketing' },
	{
		guideName: 'Maths Degree',
		rankingsSlug: 'mathematics',
		courseSearchSlug: 'mathematics',
	},
	{
		guideName: 'Media Studies Degree',
		rankingsSlug: 'media-journalism-and-communications',
		courseSearchSlug: 'media-and-communication-studies',
	},
	{
		guideName: 'Medical Technology Degree',
		rankingsSlug: '',
		courseSearchSlug: 'medical-biotechnology',
	},
	{
		guideName: 'Medicine Degree',
		rankingsSlug: 'medicine-and-dentistry',
		courseSearchSlug: 'medicine',
	},
	{
		guideName: 'Mental Health Nursing Degree',
		rankingsSlug: '',
		courseSearchSlug: 'mental-health-nursing',
	},
	{
		guideName: 'Microbiology Degree',
		rankingsSlug: '',
		courseSearchSlug: 'microbiology',
	},
	{
		guideName: 'Middle Eastern Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'modern-middle-eastern-studies',
	},
	{ guideName: 'Midwifery Degree', rankingsSlug: '', courseSearchSlug: 'midwifery' },
	{
		guideName: 'Modern Foreign Languages Degree',
		rankingsSlug: 'modern-languages-and-linguistics',
		courseSearchSlug: 'modern-languages',
	},
	{
		guideName: 'Music Degree',
		rankingsSlug: 'music-and-performing-arts',
		courseSearchSlug: 'music',
	},
	{ guideName: 'Nursing Degree', rankingsSlug: '', courseSearchSlug: 'nursing' },
	{
		guideName: 'Ocean Studies Degree',
		rankingsSlug: '',
		courseSearchSlug: 'ocean-sciences',
	},
	{
		guideName: 'Ophthalmology Degree',
		rankingsSlug: '',
		courseSearchSlug: 'ophthalmic-dispensing',
	},
	{
		guideName: 'Oral Science Degree',
		rankingsSlug: 'medicine-and-dentistry',
		courseSearchSlug: 'dentistry',
	},
	{ guideName: 'Pathology Degree', rankingsSlug: '', courseSearchSlug: 'pathology' },
	{ guideName: 'Pharmacy Degree', rankingsSlug: '', courseSearchSlug: 'pharmacy' },
	{
		guideName: 'Philosophy Degree',
		rankingsSlug: 'philosophy',
		courseSearchSlug: 'philosophy',
	},
	{
		guideName: 'Photography Degree',
		rankingsSlug: '',
		courseSearchSlug: 'photography',
	},
	{ guideName: 'Physics Degree', rankingsSlug: 'physics', courseSearchSlug: 'physics' },
	{ guideName: 'Physiology Degree', rankingsSlug: '', courseSearchSlug: 'physiology' },
	{
		guideName: 'Politics Degree',
		rankingsSlug: 'politics-and-international-studies',
		courseSearchSlug: 'politics',
	},
	{
		guideName: 'Property Management Degree',
		rankingsSlug: '',
		courseSearchSlug: 'property-management',
	},
	{
		guideName: 'Psychology Degree',
		rankingsSlug: 'psychology',
		courseSearchSlug: 'psychology',
	},
	{ guideName: 'Radiography Degree', rankingsSlug: '', courseSearchSlug: 'radiology' },
	{
		guideName: 'Social Work Degree',
		rankingsSlug: 'social-work',
		courseSearchSlug: 'social-work',
	},
	{
		guideName: 'Sociology Degree',
		rankingsSlug: 'sociology',
		courseSearchSlug: 'sociology',
	},
	{
		guideName: 'Sports Science Degree',
		rankingsSlug: 'sport',
		courseSearchSlug: 'sport-and-exercise-sciences',
	},
	{
		guideName: 'Teacher Training Degree',
		rankingsSlug: 'teaching-and-education',
		courseSearchSlug: 'secondary-teaching',
	},
	{
		guideName: 'Theology Degree',
		rankingsSlug: 'theology-and-religious-studies',
		courseSearchSlug: 'theology',
	},
	{ guideName: 'Tourism Degree', rankingsSlug: '', courseSearchSlug: 'tourism' },
	{ guideName: 'Toxicology Degree', rankingsSlug: '', courseSearchSlug: 'toxicology' },
	{
		guideName: 'Urban Planning Degree',
		rankingsSlug: '',
		courseSearchSlug: 'urban-and-regional-planning',
	},
	{
		guideName: 'Veterinary Degree',
		rankingsSlug: 'veterinary-sciences',
		courseSearchSlug: 'veterinary-medicine',
	},
	{ guideName: 'Zoology Degree', rankingsSlug: '', courseSearchSlug: 'zoology' },
];
